import React from 'react';
import './_ApplicationWait.scss';

const ApplicationWait: React.FC = () => {
  return <div className="wait-modal">Your data is being processed, please wait...</div>;
};

export default ApplicationWait;
